import { queryOptions } from '@tanstack/react-query';
import { REVIEW_QUERY_KEYS } from './keys';
import { reviewAPIClient } from '../reviewAPIClient';
import type {
  GetProductReviewsRequest,
  GetProductReviewsResponse,
  GetAIProductReviewsRequest,
  GetAIProductReviewsResponse,
  GetCuratedReviewsRequest,
  GetCuratedReviewsResponse,
  ReviewStatisticsRequest,
  ReviewStatisticsResponse,
} from './types';

export const REVIEW_QUERIES = {
  getProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    queryOptions<GetProductReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getProductReviews(productId, params),
      queryFn: () => reviewAPIClient.getProductReviews(productId, params),
    }),

  getAIProductReviews: (productId: number, params?: Omit<GetAIProductReviewsRequest, 'productId'>) =>
    queryOptions<GetAIProductReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getAIProductReviews(productId, params),
      queryFn: () => reviewAPIClient.getAIProductReviews(productId, params),
    }),

  getCuratedReviews: (params?: GetCuratedReviewsRequest) =>
    queryOptions<GetCuratedReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getCuratedReviews(params),
      queryFn: () => reviewAPIClient.getCuratedReviews(params),
    }),

  getReviewStatistics: (params: ReviewStatisticsRequest) =>
    queryOptions<ReviewStatisticsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewStatistics(params),
      queryFn: () => reviewAPIClient.getReviewStatistics(params),
    }),
};
